export default "__VITE_ASSET__DrrIS_YM__"